import { ListGroup } from 'react-bootstrap';
import './actionCard.css';

// ActionCards — the single outer frame for a group of actions: one bordered box
// with a hairline divider between each ActionCard row. Always wrap ActionCard(s)
// in this, even a single one, so every Actions section looks the same. Margin
// matches Bootstrap's own <hr/> (1rem top/bottom) since this frame replaces the
// hr that used to sit under the "Actions" heading.
export function ActionCards({ children }) {
  return (
    <ListGroup className="action-cards" style={{ marginTop: '1rem', marginBottom: '1rem' }}>
      {children}
    </ListGroup>
  );
}

// ActionCard — a single action row: the action control(s) on one side, muted
// helper text on the other. Must be rendered inside <ActionCards>, which also
// gives every button in the frame the compact metrics of .btn-compact (see
// index.css) so they match the "Add Readme" affordance on a blob page.
// minHeight gives short single-line rows the same comfortable height as
// multi-line ones (whose taller helper text expands the row past this floor).
export default function ActionCard({ helper, children }) {
  return (
    <ListGroup.Item
      className="d-flex align-items-center"
      style={{ gap: 14, padding: '10px 16px', minHeight: 58 }}
    >
      <div className="d-flex" style={{ gap: 8, flexShrink: 0 }}>{children}</div>
      <span className="text-muted text-right" style={{ fontSize: '0.8rem', flexGrow: 1 }}>{helper}</span>
    </ListGroup.Item>
  );
}
